import React, { useLayoutEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CaretRightOutlined, PlusOutlined } from "@ant-design/icons";
import SkeletonLoad from "../../components/Skeleton/SkeletonLoad";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button, Form, Input, DatePicker, Collapse, Row, Col, Select, Table, Spin } from "antd";
import Tables from "../../components/Table/Tables";
import { salesPersonListColumns } from "../../utils/cols";
import { getRights } from "../../redux/actions/userRights.action";
import moment from "moment";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { useHistory } from "react-router-dom";
import { ReadCookie } from "../../utils/readCookie";
import { dateChecker } from "../../components/CheckDate/checkDate";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import { useCallback, useEffect } from "react";
import { getOrderStatus } from "../../redux/actions/orderStatus.action";
import { getFactor } from "../../redux/actions/factor.action";
import { createInvoiceEmail, createInvoiceEmailTest, getInvoiceEmail } from "../../redux/actions/invoiceEmail.action";
import notification from "../../utils/notification";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { getModaInvoiceUpdate, updateModaInvoiceUpdate } from "../../redux/actions/modaInvoiceUpdate.action";

const ModaInvoiceUpdate = ({ token }) => {
    TabTitle("Moda Invoice Update")
    const [form] = Form.useForm();
    const history = useHistory();
    const dispatch = useDispatch();
    const { saleOrderFormData, modaInvoiceUpdate } = useSelector((state) => state);
    const { Panel } = Collapse;
    const companyId = ReadCookie("defaultCompany");
    const menuId = ReadCookie("menuId");
    const [lines, setLines] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState([])
    const [emailSending, setEmailSending] = useState(false);



    const onFinish = async (e) => {

        await form.validateFields().then((values) => {
            setLoading(true);
            dispatch(getModaInvoiceUpdate(token, values)).then((res) => {
                if (res?.type === "GET_MODA_INVOICE_UPDATE_SUCCESS") {

                    setLoading(false);
                    downloadExcelFileData(res?.payload?.data);
                    setLines(res?.payload?.data);
                }
            }).catch((error) => {
                setLoading(false);
            })
        })
    }
    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v) => {

                return {
                    "Invoice No)": v["invoice_header_no"],
                    "Invoice Date": v["invoice_date"],
                    "Po #": v["reference_no"],
                    "Customer Name": v["customer_name"],
                    "Qty": v["quantity"],
                    "External Invoice No": v["external_invoice_no"],

                };
            })
        )
    }

    const columns = [
        {
            title: "Invoice No",
            dataIndex: "invoice_header_no",
            width: 80,
            fixed: 'left',

        },
        {
            title: "Invoice Date",
            dataIndex: "invoice_date",
            width: 120,
        },
        {
            title: "PO #",
            dataIndex: "reference_no",
            width: 140,
            // align: "right"
        },
        {
            title: "Customer Name",
            dataIndex: "customer_name",
            width: 140,
        },

        {
            title: "Quantity",
            dataIndex: "quantity",
            width: 140,
            // align: "right"
        },
        {
            title: "External Invoice No",
            dataIndex: "external_invoice_no",
            width: 140,
            // align: "right"
        },
         {
            title: "External Invoice Date",
            dataIndex: "external_invoice_date",
            width: 120,
        },

    ]


    function debounce(cb, delay = 1000) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                cb(...args);
            }, delay);
        };
    }


    const handleChanges = (val) => {
        dispatch(getSaleOrderFormData(token, companyId, menuId, val, "")).then(
            (res) => {
                if (
                    res.type === "GET_GENDER_HEADER_DATA_SUCCESS" &&
                    res?.payload.length === 0
                ) {
                    notification("warning", "Empty List");
                }
                if (res?.payload?.customerDetail?.length === 0) {
                }
            }
        );
    };

    const optimizedFn = useCallback(debounce(handleChanges), []);


    let result =
        selectedRows.length > 0 &&
        selectedRows?.reduce(function (r, a) {
            r[a.email] = r[a.email] || [];
            r[a.email].push(a);
            return r;
        }, Object.create(null));

    const selectedRow = result ? Object.values(result) : [];



    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    };

    // const sendEmail = () => {

    //     selectedRow.map((resp)=> {
    //         dispatch(createInvoiceEmail(token, resp)).then((res) => {
    //             if (res?.type === "CREATE_INVOICE_EMAIL_SUCCESS") {
    //                 notification("success", "Customers", res?.payload);
    //                 setSelectedRows([]);
    //                 setLines([]);
    //             }
    //         });
    //     })
    // }

    console.log("selectedRow", selectedRow)
    // const sendEmail = () => {
    //     selectedRow.map((resp) => {
    //         dispatch(createInvoiceEmailTest(token, resp)).then((res) => {
    //             if (res?.type === "CREATE_INVOICE_EMAIL_SUCCESS") {
    //                 notification("success", "Customers", res?.payload);
    //                 setSelectedRows([]);
    //                 setLines([]);
    //             }
    //         });
    //     })
    // }

    const sendEmail = () => {
        setEmailSending(true); // optional: use if you want a spinner for "sending emails"

        Promise.all(
            selectedRow.map((resp) =>
                dispatch(createInvoiceEmailTest(token, resp))
            )
        ).then(async (results) => {
            let allSuccess = true;

            results.forEach((res) => {
                if (res?.type === "CREATE_INVOICE_EMAIL_SUCCESS") {
                    notification("success", "Customers", res?.payload);
                } else {
                    allSuccess = false;
                    notification("error", "Error", "Failed to send one or more emails.");
                }
            });

            // Instead of clearing selected rows and lines, fetch updated data
            setLoading(true);
            try {
                const values = form.getFieldsValue(); // assuming form is in scope
                const res = await dispatch(getInvoiceEmail(token, values));
                if (res?.type === "GET_INVOICE_EMAIL_SUCCESS") {
                    downloadExcelFileData(res?.payload?.data);
                    setLines(res?.payload?.data);
                    setSelectedRows([]); // clear selected rows after refresh
                }
            } catch (err) {
                notification("error", "Error", "Failed to refresh invoice data.");
            } finally {
                setLoading(false);
            }

        }).finally(() => {
            setEmailSending(false); // optional cleanup
        });
    };




    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader title={"Moda Invoice Update"} />
                <div className="bodyStyle">
                    <Collapse
                        style={{ width: "99%", margin: "10px" }}
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    >
                        <Panel header="Filters" key="1" className="site-collapse-custom-panel" extra={<Button
                            onClick={() => {
                                history.push("/saleperson");
                            }}
                            className="iconBtn crudBTN"
                            shape="circle"
                        />}>
                            <Form
                                form={form}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}

                                onFinish={onFinish}
                                autoComplete="off"
                            >
                                <Row>
                                    <Col xs={24} xl={8}>
                                        <Form.Item label="From Date" name="fromDate"
                                        >
                                            <DatePicker
                                                size="small"
                                                id="fromData"
                                                format="MM-DD-YYYY"
                                                allowClear
                                                className="dateInput customInputs"
                                                defaultValue={moment()}
                                                value={moment()}

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={8}>
                                        <Form.Item label="To Date" name="toDate"
                                        >
                                            <DatePicker
                                                size="small"
                                                id="toDate"
                                                format="MM-DD-YYYY"
                                                allowClear
                                                className="dateInput customInputs"
                                                defaultValue={moment()}
                                                value={moment()}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={8}>
                                        <Form.Item
                                            name="customer"
                                            label="Customer"
                                        >
                                            <Select
                                                size="small"
                                                autoComplete={"nope"}
                                                allowClear
                                                showSearch
                                                optionFilterProp="children"
                                                loading={saleOrderFormData.loading}

                                                onSearch={(value) => optimizedFn(value)}
                                            >
                                                {saleOrderFormData?.payload?.customerDetail.map(
                                                    (item) => {
                                                        return (
                                                            <Select.Option
                                                                key={item.customer_id}
                                                                value={item.customer_id}
                                                            >
                                                                {" "}
                                                                {`${item.customer_code} - ${item.customer_name}`}
                                                            </Select.Option>
                                                        );
                                                    }
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button type="primary" htmlType="submit">
                                        Search
                                    </Button>
                                </div>
                                {/* {
                                    selectedRows.length > 0 ? (
                                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                                            <Button
                                                loading={emailSending || loading}  // show spinner on button
                                                disabled={emailSending || loading} // disable during process
                                                type="primary"
                                                onClick={sendEmail}
                                            >
                                                Send Email {selectedRows.length}
                                            </Button>
                                        </div>
                                    ) : null
                                } */}
                            </Form>
                        </Panel>
                    </Collapse>

                    <div className="mainProductContainer">
                        <div style={{ padding: 10 }}>
                            {
                                loading ? (
                                    <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                                        <Spin size='large' />
                                    </div>
                                ) : (
                                    lines.length > 0 ? (
                                        <Table
                                            title={() =>
                                                selectedRows.length > 0 ? (
                                                    <div style={{ display: "flex", gap: 20, width: 500 }}>
                                                        <Input placeholder="Enter External Invoice No"
                                                            onChange={(val) => {
                                                                console.log("Value", val.target.value);
                                                                let items = selectedRows.map((item) => {
                                                                    item.external_invoice_no = val.target.value;
                                                                    return item;
                                                                });
                                                                setSelectedRows(items);
                                                            }}
                                                        />
                                                        <Button
                                                            onClick={() => {
                                                                setLoading(true);
                                                                dispatch(updateModaInvoiceUpdate(token, selectedRows)).then((res) => { 
                                                                    if(res?.type === "UPDATE_MODA_INVOICE_UPDATE_SUCCESS"){
                                                                        setLoading(false);                                                            
                                                                        setSelectedRows([]);
                                                                        // setLines([]);
                                                                        notification("success", "Success", res?.payload?.message);
                                                                    }
                                                                })
                                                           
                                                            }}
                                                        >Update</Button>
                                                    </div>
                                                ) : null
                                                // <CSVLink
                                                //     filename={"invoice-email.csv"}
                                                //     data={excelData}
                                                //     onClick={() => {

                                                //     }}
                                                // >
                                                //     Download Excel
                                                // </CSVLink>
                                            }
                                            rowSelection={{
                                                ...rowSelection,
                                            }}
                                            rowKey="invoice_header_id"
                                            scroll={450}
                                            perPage={100}
                                            columns={columns}
                                            dataSource={lines.length > 0 ? lines : []}
                                            loading={lines?.loading}
                                            paginate
                                            pagination={{
                                                defaultCurrent: 1,
                                                defaultPageSize: 100,
                                                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
                                            }}
                                        // summary={(pageData) => {
                                        //     let qty = pageData.reduce(function (
                                        //         previousValue,
                                        //         currentValue
                                        //     ) {
                                        //         return (previousValue += parseFloat(
                                        //             currentValue.quantity === "" ? 0 : currentValue.quantity
                                        //         ));
                                        //     },
                                        //         0);
                                        //     let amount = pageData.reduce(function (
                                        //         previousValue,
                                        //         currentValue
                                        //     ) {
                                        //         return (previousValue += parseFloat(
                                        //             currentValue.net_amount === "" ? 0 : currentValue.net_amount
                                        //         ));
                                        //     },
                                        //         0);
                                        //     return (
                                        //         <>
                                        //             <Table.Summary.Row>
                                        //                 <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
                                        //                 </Table.Summary.Cell>
                                        //                 <Table.Summary.Cell></Table.Summary.Cell>
                                        //                 <Table.Summary.Cell></Table.Summary.Cell>
                                        //                 <Table.Summary.Cell></Table.Summary.Cell>
                                        //                 <Table.Summary.Cell><p style={{ textAlign: "right" }}> Total : </p>
                                        //                 </Table.Summary.Cell>
                                        //                 <Table.Summary.Cell>
                                        //                     <p style={{ textAlign: "right" }} className="totalquantity">
                                        //                         {qty.toLocaleString("en-US")}
                                        //                     </p>
                                        //                 </Table.Summary.Cell>
                                        //                 <Table.Summary.Cell>
                                        //                     <p style={{ textAlign: "right" }} className="totalquantity">
                                        //                         $ {amount.toLocaleString("en-US")}
                                        //                     </p>
                                        //                 </Table.Summary.Cell>
                                        //             </Table.Summary.Row>
                                        //             <Table.Summary.Row>
                                        //                 <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(totalSum()).format("0,0.00")}
                                        //                 </Table.Summary.Cell>
                                        //             </Table.Summary.Row>
                                        //         </>
                                        //     );
                                        // }}
                                        />
                                    ) : <div
                                        style={{
                                            backgroundColor: "#CCCCCC",
                                            borderWidth: "1pt",
                                            borderStyle: "Dashed",
                                            fontWeight: "bold",
                                            height: "25px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        No record(s)
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ModaInvoiceUpdate;